import { EmptyMenuPropsFactory, IMenuProps } from '@/entities/Menu'

export const mains: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'news',
    title: 'ニュース',
    icon: 'icon-news.svg',
    policy: ['normal', 'unchargeable'],
    notify: true
  }),
  EmptyMenuPropsFactory({
    id: 'message',
    title: '病院掲示板',
    icon: 'icon-calendar.svg',
    policy: ['normal', 'unchargeable'],
    notify: true
  }),
  EmptyMenuPropsFactory({
    id: 'order',
    title: '支払い/領収書',
    icon: 'icon-card.svg',
    policy: ['normal', 'locked']
  }),
  EmptyMenuPropsFactory({
    id: 'hospital',
    title: '担当病院（25日締め）',
    icon: 'icon-hospital.svg',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'room',
    title: '業務連絡',
    icon: 'icon-message.svg',
    policy: ['normal', 'unchargeable'],
    notify: true
  }),
  EmptyMenuPropsFactory({
    id: 'appointment',
    title: 'アポ申請 / 立会申請',
    icon: 'icon-calendar.svg',
    label: '病院に申請',
    policy: ['normal', 'unchargeable'],
    notify: true
  }),
  EmptyMenuPropsFactory({
    id: 'schedule',
    title: '訪問予定 / 訪問結果',
    icon: 'icon-data-check.svg',
    policy: ['normal', 'unchargeable'],
    label: '自己申告用'
  }),
  EmptyMenuPropsFactory({
    id: 'admission',
    title: 'チェックイン履歴',
    policy: ['normal', 'unchargeable'],
    icon: 'icon-admission.svg'
  })
]

export const subs: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'faq',
    title: 'よくあるご質問',
    icon: 'icon-faq.svg',
    href: 'https://monitaro.tayori.com/q/monitarofaq/',
    target: '_blank'
  }),
  EmptyMenuPropsFactory({
    id: 'manual',
    title: '使い方 / マニュアル',
    icon: 'icon-question.svg',
    href: 'https://media.monitaro.jp/assets/MONITAROマニュアル企業担当者向け.pdf',
    target: '_blank'
  }),
  EmptyMenuPropsFactory({
    id: 'account-withdraw',
    title: '退会（最終支払）',
    icon: 'icon-times-circle.svg'
  })
]

export const accounts: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'profile',
    title: 'プロフィールの変更',
    icon: 'icon-circle-user-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-email',
    title: 'メールアドレスの変更',
    icon: 'icon-envelope-regular.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-password',
    title: 'パスワードの変更',
    icon: 'icon-lock-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'logout',
    title: 'ログアウト',
    icon: 'icon-logout.svg'
  })
]

export const bottom: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'room',
    title: '業務連絡',
    icon: 'icon-message.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'appointment',
    title: 'アポ管理',
    icon: 'icon-calendar.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'schedule',
    title: '訪問申告',
    icon: 'icon-data-check.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'news',
    title: 'ニュース',
    icon: 'icon-news.svg',
    notify: true
  }),
  EmptyMenuPropsFactory({
    id: 'menu',
    title: 'メニュー',
    icon: 'icon-bars-sharp-solid.svg'
  })
]

export const configs: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'profile',
    title: 'プロフィールの変更',
    icon: 'icon-circle-user-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-email',
    title: 'メールアドレスの変更',
    icon: 'icon-envelope-regular.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-password',
    title: 'パスワードの変更',
    icon: 'icon-lock-solid.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'logout',
    title: 'ログアウト',
    icon: 'icon-logout.svg'
  }),
  EmptyMenuPropsFactory({
    id: 'account-withdraw',
    title: '退会（最終支払）',
    icon: 'icon-user-minus-solid.svg'
  })
]

export const used: IMenuProps[] = [
  EmptyMenuPropsFactory({
    id: 'index',
    title: 'トップページ'
  }),
  EmptyMenuPropsFactory({
    id: 'login',
    title: 'ログイン'
  }),
  EmptyMenuPropsFactory({
    id: 'logout',
    title: 'ログアウト'
  }),
  EmptyMenuPropsFactory({
    id: 'forget',
    title: 'パスワードの再発行'
  }),
  EmptyMenuPropsFactory({
    id: 'signup',
    title: '新規アカウント作成'
  }),
  EmptyMenuPropsFactory({
    id: 'activation-id',
    title: 'メールアドレス認証'
  }),
  EmptyMenuPropsFactory({
    id: 'config',
    title: '設定'
  }),
  EmptyMenuPropsFactory({
    id: 'news-id',
    title: 'ニュース'
  }),
  EmptyMenuPropsFactory({
    id: 'news-recruitment-id',
    title: '求人詳細',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'news-recruitment-finished-id',
    title: '求人申し込み完了',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'finished',
    title: 'リダイレクト',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'message-id',
    title: '病院掲示板'
  }),
  EmptyMenuPropsFactory({
    id: 'profile-company',
    title: '勤務先情報'
  }),
  EmptyMenuPropsFactory({
    id: 'profile-manage',
    title: '担当情報'
  }),
  EmptyMenuPropsFactory({
    id: 'profile-supervisor',
    title: '上司'
  }),
  EmptyMenuPropsFactory({
    id: 'profile-confirm',
    title: '利用規約'
  }),
  EmptyMenuPropsFactory({
    id: 'hospital-add',
    title: '担当病院の追加',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'hospital-id',
    title: '詳細',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-add',
    title: 'アポ申請 / 立会申請',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-id',
    title: 'アポ申請 / 立会申請内容',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-id-edit',
    title: '日程の再調整',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-config',
    title: '外部カレンダー連携',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'appointment-calendar',
    title: 'マイカレンダー',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'schedule-add',
    title: '訪問予定の入力',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'schedule-id',
    title: '訪問予定',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'schedule-id-edit',
    title: '訪問予定の編集',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'schedule-id-result',
    title: '訪問結果の作成',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'result-add',
    title: '訪問結果の入力',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'result-id',
    title: '訪問結果',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'result-id-edit',
    title: '訪問結果の編集',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'room-id',
    title: '業務連絡',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'room-id-member',
    title: 'グループユーザー一覧',
    policy: ['normal', 'unchargeable']
  }),
  EmptyMenuPropsFactory({
    id: 'order-id',
    title: '支払い/領収書'
  }),
  EmptyMenuPropsFactory({
    id: 'oauth-google',
    title: '外部カレンダー連携'
  }),
  EmptyMenuPropsFactory({
    id: 'oauth-microsoft',
    title: '外部カレンダー連携'
  }),
  EmptyMenuPropsFactory({
    id: 'admission-checkin',
    title: 'チェックイン'
  })
]

const all = mains.concat(subs).concat(accounts).concat(configs).concat(used)

export default all
